// © 2026 Orpyx Medical Technologies Inc.

import React, {memo} from "react";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {createStyles, Theme, withStyles} from "@material-ui/core";
import TableCell, { TableCellProps } from "@material-ui/core/TableCell";
import {Teal} from "orpyx-web-common";
import {PatientActivityLogTableHeaderProps} from "./patient-activity-log-table-header.interface";

const GreenTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: Teal,
            color: '#FFF',
            fontSize: 14,
            verticalAlign: 'baseline',
            padding: '15px 10px',
        },
        body: {
            fontSize: 14,
        },
    }),
)((props: TableCellProps) => {
    return <TableCell {...props} />
});

const ActionTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: Teal,
            color: '#FFF',
            fontSize: 14,
            verticalAlign: 'baseline',
            padding: '10px 15px 10px 0',
        },
        body: {
            fontSize: 14,
        },
    }),
)((props: TableCellProps) => {
    return <TableCell {...props} />
});

export const PatientActivityLogTableHeader = memo((props: PatientActivityLogTableHeaderProps) => {
    return (<TableHead>
        <TableRow>
            <GreenTableCell>Action Required Flags</GreenTableCell>
            <GreenTableCell>Date</GreenTableCell>
            <GreenTableCell>Notes / Suggested Action</GreenTableCell>
            <GreenTableCell className={props.classes.actionIconCell}/>
            <ActionTableCell className={props.classes.actionLabelHeaderCell}>Action / Primary Concern</ActionTableCell>
            <GreenTableCell>Name of Monitoring Personnel</GreenTableCell>
            <GreenTableCell>Monitored Time</GreenTableCell>
            <GreenTableCell colSpan={2} align="center">Download Documents</GreenTableCell>
        </TableRow>
    </TableHead>)
});